export function buildEndpoint(
  basePath: string,
  schema: string,
  params: Record<string, string> = {}
) {
  const keys = Object.keys(params);
  let path = schema;

  keys.forEach((key) => {
    if (params[key] == null) path = path.replace(`{${key}}`, '');
    else path = path.replace(`{${key}}`, params[key]);
  });

  const url = new URL(path, 'https://www.example.com');
  const searchParams = new URLSearchParams(url.search);

  searchParams.forEach((value, key) => {
    if (params[key] == null && !value) {
      url.searchParams.delete(key);
    }
  });

  return basePath + url.pathname + decodeURIComponent(url.search);
}
